// RECAPTCHA
function loadRecaptchaCallback() {
    setTimeout(function () {
        if (typeof grecaptcha == 'undefined') {
            loadRecaptchaCallback();
        } else {
            grecaptcha.render('g-recaptcha', {
                'sitekey' : recaptcha_key
            });
        }
    }, 1000);
}

jQuery(function($) {

    $(document).foundation();
    $('body').css('pointer-events','all'); //activate all pointer-events on body

    $(window).resize(function() {
        // console.log($(window).width());
        if (window.matchMedia('(max-width: 1023px)').matches) {
            $('#submenu-menu').addClass('nested');
        } else {
            $('#submenu-menu').removeClass('nested');
        }
    }).resize(); // inizializzo l'evento resize


    // Controllo al click se l'attributo 'aria-expanded' ha stato 'true' o 'false'
    $(function () {
      $('.menu-icon').click(function(){
        var currValue = $(this).attr('aria-expanded');
        if(currValue == 'true'){
          currValue = 'false';
        }else{
          currValue = 'true';
        }
        // aggiungo le classi al click
        $(this).attr('aria-expanded', currValue);
        $('.nav-icon').toggleClass('close open');
        $('.fix-off-canvas').toggleClass('is-fixed');

        // chiudo la barra di ricerca quando apro il menu su mobile
        if ( $('.nav-icon').hasClass( 'open' ) ) {
            $('.header').removeClass('active');
            $('.search').removeClass('active');
        }


      })

    });


    // Search
    $('.search').on('click', function(){
        // $('.search-bar').toggleClass('active');
        $(this).toggleClass('active');
        $('.header').toggleClass('active');

        // chiudo la barra del menu quando apro la barra di ricerca su mobile
        if ( $('.search').hasClass( 'active' ) ) {
            $('.off-canvas').removeClass('is-open');
            $('.nav-icon').removeClass('open');
            $('.fix-off-canvas').removeClass('is-fixed');
            $('.off-canvas').addClass('is-closed');
            $('.nav-icon').addClass('close');
        }

    });

    $('.js-off-canvas-overlay').click(function(){
      $('.nav-icon').toggleClass('close open');
    });

});

function openContactForm (id, object) {
    $('#'+id).foundation('open');
    $.get('/send-contact', {
        object: object
    }, function (data) {
        $('#contact-form').replaceWith(data);
        loadRecaptchaCallback();
    });
}

$(document).on('submit', '.contact-form', function (e) {
    e.preventDefault();

    var form = $(this);
    if($('.form_modal').length > 0) {
        $('#loader-contacts-modal').show();
    }
    else
    {
        $('#loader-contacts').show();
    }
    $('#contact-form').hide();

    $.post('/send-contact', form.serializeArray(), function (data) {
        $('#loader-contacts').hide();
        $('#loader-contacts-modal').hide();
        $('#contact-form').show();
        form.replaceWith(data.html);
        //loadRecaptchaCallback();
    });
});

$(document).on('submit', '.newsletter-form', function (e) {
    e.preventDefault();

    var form = $(this);

    $.post('/subscribe-newsletter', form.serializeArray(), function (data) {
        form.replaceWith(data.html);
        $('ul.accordion').foundation();
    });
});
